export function getEnvironment(): string {
  if (
    !location.host ||
    location.host.endsWith('localhost') ||
    location.host.endsWith('127.0.0.1')
  ) {
    return 'local';
  }

  if (location.host.endsWith('.kin.insure') || location.host.endsWith('.kin.com')) {
    return 'production';
  }

  if (location.host.endsWith('app.dev.kin.co')) {
    return 'development';
  }

  if (location.host.endsWith('.kin.haus')) {
    return 'staging';
  }

  return 'unknown';
}
